import { Fragment, useCallback, useState } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import RouterFilterTagButton from '../../common/components/RouterFilterTagButton';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_UNEXPANDED_TAGS = 3;
const renderFilterTagButton = ({
  getTagText,
  isPreview,
  onClick,
  queryField,
  value
}) => /*#__PURE__*/_jsx(View, {
  marginInlineStart: "0",
  marginInlineEnd: "100",
  children: /*#__PURE__*/_jsx(RouterFilterTagButton, {
    disabled: isPreview,
    onClick: onClick,
    queryField: queryField,
    value: value,
    children: getTagText ? getTagText(value) : value
  }, `${queryField}-${value}`)
});
export default function ExpandableTagsSection({
  getTagText,
  isPreview,
  onTrackInteraction,
  queryField,
  tags
}) {
  const expandCount = tags.length - MAX_UNEXPANDED_TAGS;
  const shortenedTagsList = tags.slice(0, MAX_UNEXPANDED_TAGS);
  const [expanded, setExpanded] = useState(false);
  const trackInteraction = useCallback((action, eventProperties = {}) => {
    onTrackInteraction(action, Object.assign({}, eventProperties, {
      section: 'sidebar about',
      filter: queryField
    }));
  }, [onTrackInteraction, queryField]);
  const trackFilterTagClick = useCallback(value => {
    trackInteraction('click filter tag', {
      value
    });
  }, [trackInteraction]);
  if (expanded || tags.length <= MAX_UNEXPANDED_TAGS) {
    return /*#__PURE__*/_jsx(Fragment, {
      children: tags.map(value => renderFilterTagButton({
        getTagText,
        isPreview,
        onClick: () => trackFilterTagClick(value),
        queryField,
        value
      }))
    });
  }
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    wrap: "wrap",
    children: [shortenedTagsList.map(value => renderFilterTagButton({
      getTagText,
      isPreview,
      onClick: () => trackFilterTagClick(value),
      queryField,
      value
    })), /*#__PURE__*/_jsxs(UIButton, {
      "aria-label": unescapedText(`marketplace-assets-ui.details.assetInfo.expandTags.${queryField}`),
      use: "transparent",
      onClick: () => {
        setExpanded(true);
        trackInteraction('click expand tags link');
      },
      className: "p-x-0 p-y-1",
      responsive: false,
      children: ["+", expandCount]
    })]
  });
}